import React from 'react';
import PropTypes from 'prop-types';
import FrequencyInput from './FrequencyInput';
import MessageErreur from '../../UI/MessageErreur/MessageErreur';
import S from '../ProfilTasks/FormulaireTasks/FormulaireTasks.module.scss';

/**
 * Section d'exécution de la tâche (active, mode, fréquence)
 *
 * erreur est une clé de traduction issue du schéma de tâche : fréquence
 * manquante, aucun jour coché, intervalle nul ou date de fin avant le début.
 * Elle se pose sous le bloc de fréquence, qui regroupe tous ces champs.
 */
const TaskExecutionSection = ({
  active,
  mode,
  frequence,
  intervalYears,
  intervalMonths,
  intervalWeeks,
  intervalDays,
  intervalHours,
  intervalMinutes,
  intervalSeconds,
  frequenceDate,
  frequenceTime,
  endDate,
  endTime,
  daysOfWeek,
  erreur,
  onChange,
  readOnly = false,
}) => {
  return (
    <div className={S.section}>
      <h4 className={S.sousTitre}>Exécution</h4>
      <div className={S.champGroupe}>
        <label className={S.label}>Active</label>
        <input
          type="checkbox"
          checked={!!active}
          onChange={(e) => onChange('active', e.target.checked)}
          disabled={readOnly}
          style={{ marginLeft: 8 }}
        />
      </div>
      <div className={S.champGroupe}>
        <label className={S.label}>Mode</label>
        <select
          value={mode}
          onChange={(e) => onChange('mode', e.target.value)}
          disabled={readOnly}
          style={{ padding: '6px 8px' }}
        >
          <option value="manual">Manuel</option>
          <option value="scheduled">Planifié</option>
        </select>
      </div>
      <FrequencyInput
        mode={mode}
        frequence={frequence}
        intervalYears={intervalYears}
        intervalMonths={intervalMonths}
        intervalWeeks={intervalWeeks}
        intervalDays={intervalDays}
        intervalHours={intervalHours}
        intervalMinutes={intervalMinutes}
        intervalSeconds={intervalSeconds}
        frequenceDate={frequenceDate}
        frequenceTime={frequenceTime}
        endDate={endDate}
        endTime={endTime}
        daysOfWeek={daysOfWeek}
        onChange={onChange}
        readOnly={readOnly}
      />
      <MessageErreur cle={erreur} />
    </div>
  );
};

TaskExecutionSection.propTypes = {
  active: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['manual', 'scheduled']).isRequired,
  frequence: PropTypes.string,
  intervalYears: PropTypes.number,
  intervalMonths: PropTypes.number,
  intervalWeeks: PropTypes.number,
  intervalDays: PropTypes.number,
  intervalHours: PropTypes.number,
  intervalMinutes: PropTypes.number,
  intervalSeconds: PropTypes.number,
  frequenceDate: PropTypes.string,
  frequenceTime: PropTypes.string,
  endDate: PropTypes.string,
  endTime: PropTypes.string,
  daysOfWeek: PropTypes.string,
  erreur: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

TaskExecutionSection.defaultProps = {
  frequence: '',
  intervalYears: 0,
  intervalMonths: 0,
  intervalWeeks: 0,
  intervalDays: 0,
  intervalHours: 0,
  intervalMinutes: 0,
  intervalSeconds: 0,
  frequenceDate: '',
  frequenceTime: '',
  endDate: '',
  endTime: '',
  daysOfWeek: '',
  erreur: null,
  readOnly: false,
};

export default React.memo(TaskExecutionSection);
